



















































import {Component, Vue, Prop} from 'vue-property-decorator';
import _ from 'lodash';


@Component({
  components: {
  }
})
export default class ReferrerDomain extends Vue {
  @Prop() conditions: any;

  mounted() {
    if (!this.conditions.referrerDomain) {
      this.$set(this.conditions, 'referrerDomain', {
        predicate: this.predicate,
        values: []
      });
    } else {
      if (this.conditions.referrerDomain.predicate) {
        this.predicate = this.conditions.referrerDomain.predicate;
      }
    }
  }

  get tabs() {
    return [
      {
        label: this.t('From List'),
        key: 'fromList',
        icon: 'fas fa-list',
      },
      {
        label: this.t('Custom'),
        key: 'custom',
        icon: 'fas fa-pen',
      },
    ]
  }

  changeCustomField({ target }) {
    this.selected = _.uniq(target.value.split('\n').filter(item => !!item))
  }

  get customReferrerDomain() {
    return this.selected.join('\n')
  }

  get predicate() {
    return this.conditions.referrerDomain?.predicate || 'CONTAINS'
  }

  set predicate(value: string) {
    this.$set(this.conditions.referrerDomain, 'predicate', value);
  }

  get selected() {
    if (!this.conditions.referrerDomain) {
      return [];
    }

    return this.conditions.referrerDomain.values.map((v: string) => !v ? `[${this.t('Empty Value')}]` : v);
  }

  set selected(value: string[]) {
    const result = value.map((e: string) => e === `[${this.t('Empty Value')}]` ? '' : e);
    this.$set(this.conditions.referrerDomain, 'values', result);
  }

  get includeEmpty() {
    return !!this.conditions.referrerDomain?.values.some((v: string) => !v);
  }

  set includeEmpty(value: boolean) {
    if (value) {
      this.conditions.referrerDomain.values.push('');
    } else {
      this.conditions.referrerDomain.values.splice(this.conditions.referrerDomain.values.indexOf(''), 1);
    }
  }
}
